import * as React from 'react';
import { Overlay, SideModal, SideModalContent } from '~/common/layout/Modals';
import Head from '~/common/layout/Head';

import UserUpdateForm from './UserUpdateForm';

export default (props) => {
  const { headTitle, onClose, onSubmit, user, locations, locationHelper, errorMessage, hasDepartmentFeature, departmentOptions, hasFHIFeature } = props;

  const handleClose = (e) => {
    e.preventDefault();
    onClose();
  };

  return (
    <Overlay onClick={handleClose}>
      <SideModal>
        <Head headTitle={headTitle} />

        <SideModalContent>
          <UserUpdateForm
            onSubmit={onSubmit}
            initialValues={user}
            error={errorMessage}
            locations={locations}
            locationHelper={locationHelper}
            hasDepartmentFeature={hasDepartmentFeature}
            departmentOptions={departmentOptions}
            hasFHIFeature={hasFHIFeature}
          />
        </SideModalContent>
      </SideModal>
    </Overlay>
  );
};
